import { IntegrationKeys } from './Integration';
import { Keys as AccountIntel } from './account-intel';
import { Keys as AgentsKeys } from './agents';
import { Keys as ApiManagementKeys } from './api-management';
import { Keys as PartnerConnectionKeys } from './partner-connections';
import { Keys as AppKeys } from './app';
import { Keys as CompanyKeys } from './company';
import { Keys as CustomerKeys } from './customer';
import { Keys as EnrichKeys } from './enrich';
import { Keys as FilterKeys } from './filter';
import { Keys as ListKeys } from './list';
import { Keys as LocalRegistersKeys } from './localRegisters';
import { Keys as PeopleKeys } from './people';
import { Keys as RecentSearchKeys } from './recentSearch';
import { Keys as SearchKeys } from './search';
import { Keys as SignalsKeys } from './signals';
import { Keys as StripeKeys } from './stripe';
import { Keys as SupabaseKeys } from './supabase';
import { Keys as TeammateKeys } from './teammate';
import { Keys as TechIntelligenceKeys } from './techIntelligence';
import { Keys as WebhookKeys } from './webhook';

export const Query = {
  CompanyKeys,
  FilterKeys,
  ListKeys,
  PeopleKeys,
  RecentSearchKeys,
  SearchKeys,
  StripeKeys,
  LocalRegistersKeys,
  SupabaseKeys,
  IntegrationKeys,
  ApiManagementKeys,
  PartnerConnectionKeys,
  CustomerKeys,
  AppKeys,
  SignalsKeys,
  EnrichKeys,
  AccountIntel,
  AgentsKeys,
  WebhookKeys,
  TechIntelligenceKeys,
  TeammateKeys,
};
